import _ from 'lodash';
import userApi from '@/api/userApi';
import { fetchOnce } from '@/store/utils/fetchOnce';

export default {
	namespace: true,

	state: {
		users: {},
		connectedUsers: {},
		currUser: {},
		usersLoaded: false,
		connectedUsersLoaded: false,
	},

	mutations: {
		SET_ALL_USERS(state, users) {
			state.users = users;
		},
		SET_CONNECTED_USERS(state, users) {
			state.connectedUsers = users;
		},
		SET_CURR_USER(state, user) {
			state.currUser = user;
		},
		SET_USERS_LOADED(state, val) {
			state.usersLoaded = val;
		},
		SET_CONNECTED_USERS_LOADED(state, val) {
			state.connectedUsersLoaded = val;
		}
	},

	actions: {
		setAllUsers(vuexContext, users) {
			vuexContext.commit('SET_ALL_USERS', users);
		},
		setAllConnectedUsers(vuexContext, users) {
			vuexContext.commit('SET_CONNECTED_USERS', users);
		},
		fetchUsersIfNeeded({ state, commit }, { filterBy, view, currUserId }) {
			if (state.usersLoaded) return Promise.resolve();
			return fetchOnce('users', () =>
				userApi.getUsers(filterBy, view, currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_USERS', data.users);
						commit('SET_USERS_LOADED', true);

						if (!_.isEmpty(data.connectedUsers)) {
							commit('SET_CONNECTED_USERS', data.connectedUsers);
							commit('SET_CONNECTED_USERS_LOADED', true);
						}
					}
					return data;
				})
			);
		},
		updateAllUsers(vuexContext, newUsers) {
			let users = vuexContext.getters.users;

			_.forEach(newUsers, (value, key) => {
				users[key] = value;
			});

			vuexContext.commit('SET_ALL_USERS', users);
		},
	},

	getters: {
		users(state) {
			if (!_.isEmpty(state.users)) {
				return state.users;
			}
			return {};
		},
		connectedUsers(state) {
			if (!_.isEmpty(state.connectedUsers)) {
				return state.connectedUsers;
			}
			return {};
		},
		currUser(state) {
			if (!_.isEmpty(state.currUser)) {
				return state.currUser;
			}
			return {};
		}
	}

}
